import {Inject, Injectable} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {isValidValue} from './common.service';
import {CommonConstants} from '@coreconstant';
import {DOCUMENT} from '@angular/common';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class SeoService {
    commonConstants = CommonConstants

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private _meta: Meta,
        private _title: Title,
        private router: Router
    ) {
        // Automatically set Canonical URL on every route change
        this.router.events.subscribe(() => {
            this.setCanonicalURL();
        });
    }

    /**
     * Updates the meta tags for the current page using the provided metaObject.
     * The method sets metadata for the page such as title, description, Open Graph properties, Twitter card data, and robots directives.
     *
     * @param {Object} metaObject - An object containing metadata properties. Valid fields include:
     * - title: Title of the page.
     * - description: Description content for the page.
     * - ogImageUrl: URL for the Open Graph image.
     * - ogWebUrl: URL for the Open Graph and Twitter link.
     * - robots: Value for the robots meta tag (e.g., 'noindex, nofollow').
     * Only validated values are applied to the relevant metadata tags.
     */
    setMetaTags(metaObject) {

        if (isValidValue(metaObject.title)) {
            this._title.setTitle(metaObject.title);
            this._meta.updateTag({property: 'og:title', content: metaObject.title});
            this._meta.updateTag({property: 'twitter:title', content: metaObject.title,});
        }

        this._meta.updateTag({name: 'description', content: isValidValue(metaObject.description) ? metaObject.description : ''});
        this._meta.updateTag({property: 'og:description', content: isValidValue(metaObject.description) ? metaObject.description : ''})
        this._meta.updateTag({property: 'twitter:description', content: isValidValue(metaObject.description) ? metaObject.description : ''});

        if (isValidValue(metaObject.ogImageUrl)) {
            this._meta.updateTag({
                property: 'og:image',
                content: this.commonConstants.IMAGE_KIT_URL + metaObject.ogImageUrl,
            });

            this._meta.updateTag({
                property: 'twitter:image',
                content: this.commonConstants.IMAGE_KIT_URL + metaObject.ogImageUrl,
            });
        }

        if (isValidValue(metaObject.ogWebUrl)) {
            this._meta.updateTag({
                property: 'og:url',
                content: this.commonConstants.FRONTEND_PREFIX_WITH_WWW + metaObject.ogWebUrl,
            });
            this._meta.updateTag({
                property: 'twitter:url',
                content: this.commonConstants.FRONTEND_PREFIX_WITH_WWW + metaObject.ogWebUrl,
            });
        }

        if (isValidValue(metaObject.robots)) {
            this._meta.updateTag({name: 'robots', content: 'noindex, nofollow'});
        }
    }

    setCanonicalURL() {
        const currentUrl = this.commonConstants.FRONTEND_PREFIX_WITH_WWW + this.router.url.replace(/^\/+/, '').split('?')[0];
        let link: HTMLLinkElement = this.document.querySelector(`link[rel='canonical']`) || null;
        if (link === null) {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.document.head.appendChild(link);
        }
        link.setAttribute('href', currentUrl);
    }
}
